module.exports = __webpack_public_path__ + "static/media/city2.456b47bc.jpg";